import { InjectionToken } from '@angular/core';
import { StoreConfig } from '@ngrx/store';
import * as fromActions from './app.state.actions';
import * as fromReducer from './app.state.reducer';

export const TEST_STORAGE_KEYS = new InjectionToken<keyof fromReducer.AppState[]>('TestStorageKeys');
export const TEST_LOCAL_STORAGE_KEY = new InjectionToken<string[]>('TestStorage');

export const TEST_CONFIG_TOKEN = new InjectionToken<StoreConfig<fromReducer.AppState, fromActions.TestActions>>(
    'TestConfigToken',
);
